<div [formGroup]="parts" [ngStyle]="{ opacity: readonly ? 0.5 : 1 }">
  <div *ngFor="let weekday of ['mo', 'tu', 'we', 'th', 'fr', 'sa', 'su']; let isFirst = first">
    <label>{{ weekday }}</label>
    <mat-checkbox [disabled]="disabled" [formControlName]="weekday" (blur)="_onTouched()"></mat-checkbox>
  </div>
</div>
